import React from 'react';
import { CardTitle } from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import {connect} from 'react-redux';
import { sortedCategories } from '../reducer';
import { withRouter } from 'react-router'
import { Link } from 'react-router';

class CategoryList extends React.Component {

  render() {
    return  (
      <div>
        <CardTitle title="Categories" />
        <FlatButton label="Add" containerElement={<Link to="/admin/categories/create" />} />
        <List>
        {
          this.props.categories.map((c) => {
            return <ListItem onClick={this.onClick.bind(this, c)} key={c.id} primaryText={c.title} />
          })
        }
        </List>
      </div>
    );
  }

  onClick(category) {
    this.props.router.push("/admin/categories/" + category.id);
  }
}


let mapStateToProps = (state) => {
  return {
    categories: sortedCategories(state)
  }
}

export default connect(
  mapStateToProps,
  null
)(withRouter(CategoryList));
